


































































import ModalMixin from '@/mixins/modal.mixin';
import { CrsForm } from '@resclick/crs-ui';
import { compass } from '@resclick/compass';
import { Component, Mixins, Prop, Watch } from 'vue-property-decorator';
import { i18n } from '@/i18n';

import { PrismEditor } from 'vue-prism-editor';
import 'vue-prism-editor/dist/prismeditor.min.css';
import { highlight, languages } from 'prismjs';
import 'prismjs/components/prism-clike';
import 'prismjs/components/prism-javascript';
import 'prismjs/components/prism-markup';
import 'prismjs/themes/prism-tomorrow.css';

@Component({
  components: {
    PrismEditor,
  },
})
export default class InjectionsModal extends Mixins(ModalMixin) {
  @Prop() propertyId!: string;
  @Prop() widgetId!: string;

  form!: CrsForm<'properties', 'createWidgetInjection' | 'updateWidgetInjection'>;

  get highlighter() {
    const type = {
      grammar: languages.html,
      language: 'html',
    };
    if (this.form.fields.type === 'JAVASCRIPT') {
      type.grammar = languages.js;
      type.language = 'js';
    }
    if (this.form.fields.type === 'CSS' || this.form.fields.type === 'GLOBAL_CSS') {
      type.grammar = languages.css;
      type.language = 'css';
    }

    return (code: any) => highlight(code, type.grammar, type.language);
  }

  get codeTypeOptions() {
    return [
      { label: i18n.t('GENERAL.CUSTOM_SCRIPT'), value: 'JAVASCRIPT' },
      { label: i18n.t('GENERAL.CUSTOM_CSS'), value: 'CSS' },
      { label: i18n.t('GENERAL.GLOBAL_CSS'), value: 'GLOBAL_CSS' },
      { label: i18n.t('GENERAL.GOOGLE_ANALYTICS'), value: 'GOOGLE_ANALYTICS' },
      { label: i18n.t('GENERAL.GOOGLE_TAG_MANAGER'), value: 'GOOGLE_TAG_MANAGER' },
    ];
  }

  get codeLocationsOptions() {
    return [
      { label: i18n.tc('GENERAL.WIDGET'), value: 'WIDGET' },
      { label: i18n.t('GENERAL.BOOKING_PAGE'), value: 'BOOKING_PAGE' },
    ];
  }

  @Watch('mode', { immediate: true })
  switchForm(mode: 'create' | 'update') {
    this.form = this.$crsForm('properties', mode === 'create' ? 'createWidgetInjection' : 'updateWidgetInjection', {
      isActive: false,
      name: '',
      type: 'JAVASCRIPT',
      locations: [],
      code: '',
    });
  }

  async getForm() {
    return compass.do('properties', 'findOneWidgetInjection', {
      params: {
        propertyId: this.propertyId,
        widgetId: this.widgetId,
        injectionId: this.id,
      },
    });
  }
}
